import { render } from "./All.vue?vue&type=template&id=3801b7be"
import script from "./All.vue?vue&type=script&lang=js"
export * from "./All.vue?vue&type=script&lang=js"
script.render = render

export default script